import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Select from "@atlaskit/select";

const CustomFieldSelectList = ({ onSelectField, removedOptions }) => {
  const [cfFields, setCFFields] = useState([]);
  const [value, setValue] = useState("");

  const fields = useSelector((state) => state.jira.fields);

  useEffect(() => {
    if (fields.length !== cfFields.length) {
      let options = fields.map((f) => {
        return { label: f.name, value: f.id, isCustom: f.custom, schema: f.schema };
      });
      if (removedOptions) {
        options = options.filter((opt) => {
          return !removedOptions.includes(opt.value);
        });
      }
      setCFFields(options);
    }
  }, [fields, removedOptions]);

  const onLookup = (selectedFieldObject) => {
    setValue(selectedFieldObject);
    onSelectField(selectedFieldObject);
  };

  return (
    <>
      <Select
        inputId="cf"
        className="ihub-cf-list"
        options={cfFields}
        value={value}
        placeholder="Lookup custom field"
        onChange={onLookup}
        isCompact={true}
      />
    </>
  );
};
export default CustomFieldSelectList;
